module.exports = "/static/img/node.svg?f712900ce54e965a51d1aee8b4739bcf";